import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { errorOrders } from '@/utils/errors';
import {moveOrder} from "@/services";
import PopMoveProducts from '../move-products';

interface SimpleDialogProps {
  // eslint-disable-next-line react/no-unused-prop-types
  open?: boolean;
  value: any;
  onClose: (value: string) => void;
}

export function DialogMoveProducts(props: SimpleDialogProps) {
  const { onClose, value } = props;
  const {id} = value
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    onClose(id);
  };

  const { mutateAsync: mutateChangeMethod } = useMutation({
    mutationFn: moveOrder,
    onSuccess: async () => {
      await queryClient.refetchQueries({queryKey: ['orders', 'open_orders']});
      queryClient.removeQueries({queryKey: ['orders']});
      queryClient.removeQueries({queryKey: ['orders', id]});
      enqueueSnackbar('Se cambio el producto con exito!');
      handleClose();
    },
    onError: (error: any) => {
      const newMessage = errorOrders[error.error ?? ''];
      if (newMessage) {
        enqueueSnackbar(newMessage.label, { variant: 'error' });
      } else {
        enqueueSnackbar('Problemas cambiando productos', { variant: 'error' });
      }
    },
  });


  return <PopMoveProducts current={value} onSave={mutateChangeMethod} />;
}
